export const iconFontAwesomeHolidaysGift = (
	<i className="fa-solid fa-gift"></i>
);
